module.exports = __webpack_public_path__ + "static/media/ClipIcon.5aba1384.svg";